import React from 'react';

interface SetResourceInvoiceTableProps {
  data: Array<SetResourceInvoiceData>;
  className?: string;
}

const SetResourceInvoiceTable: React.FC<SetResourceInvoiceTableProps> = ({
  data,
  className,
}) => {
  const headers = [
    '집합자원명',
    '발전소명',
    '용량 (MW)',
    '집합자원 발전량 (MWh)',
    '발전량 비율 (%)',
    '집합자원 정산금 (원)',
    '발전소 분배비율 (%)',
    '발전소 인센티브 (원)',
    '진행 상태',
  ];
  return (
    <table className={`${className} w-full`}>
      <thead>
        <tr className="h-[36px] rounded-[5px] bg-[#1F384C] text-white">
          {headers.map((value, index) =>
            index === 0 ? (
              <th
                key={index}
                className="noto-12-normal rounded-bl-[5px] rounded-tl-[5px]"
              >
                {value}
              </th>
            ) : index === headers.length - 1 ? (
              <th
                key={index}
                className="noto-12-normal rounded-br-[5px] rounded-tr-[5px]"
              >
                {value}
              </th>
            ) : (
              <th key={index} className="noto-12-normal">
                {value}
              </th>
            )
          )}
        </tr>
      </thead>
      <tbody>
        {data.map((value, index) => (
          <tr key={index} className="border-b border-[#E2E7E7]">
            {Object.keys(value).map((key) => (
              <td
                className="noto-13-normal py-[13px] text-center leading-none text-dark-6"
                key={key + index}
              >
                {value[key as keyof SetResourceInvoiceData] ?? '-'}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SetResourceInvoiceTable;
